export default {"src":"/_next/static/media/spiritory-icon-gold.cfef4fcb.svg","height":124,"width":124,"blurWidth":0,"blurHeight":0};